// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2RxHf","sendOtp":"AuthorizeToLogin_sendOtp__OA9DO"};